var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { ClipLoader as Spinner } from 'react-spinners';
import { useThemeEval } from '../hooks/use-theme-eval';
import { TickIconGlyph } from '@shapeable/icons';
export var CheckboxDefaultProps = {
  valid: true,
  size: 24,
  borderColor: 'lineMid',
  borderColorHover: 'line',
  borderWidth: 1,
  disabled: false,
  value: "yes",
  borderRadius: 0
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    overflow: hidden;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    font-weight: 500;\n    color: ", ";\n    font-size: ", ";\n    cursor: pointer;\n\n    ", "\n\n    ", "\n  "], ["\n    overflow: hidden;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: flex-start;\n    font-weight: 500;\n    color: ", ";\n    font-size: ", ";\n    cursor: pointer;\n\n    ", "\n\n    ", "\n  "])), theme.COLOR('text'), theme.FONT_SIZE(13), function (props) {
    return !props.valid && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), theme.COLOR('error'));
  }, function (props) {
    return props.disabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: default;\n      opacity: 0.5;\n    "], ["\n      cursor: default;\n      opacity: 0.5;\n    "])));
  }),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1em;\n  "], ["\n    font-size: 1em;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding-left: ", ";\n    font-size: 1em;\n    white-space: nowrap;\n  "], ["\n    padding-left: ", ";\n    font-size: 1em;\n    white-space: nowrap;\n  "])), theme.UNIT(2))
});
var InputStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    left: -9999px;\n  "], ["\n    position: absolute;\n    left: -9999px;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.FILL('primary'))
});
var CheckboxStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    align-items: center;\n    background-color: #FFF;\n    \n    ", "\n\n    ", "\n\n    ", "\n  "], ["\n    display: flex;\n    flex-shrink: 0;\n    justify-content: center;\n    align-items: center;\n    background-color: #FFF;\n    \n    ", "\n\n    ", "\n\n    ", "\n  "])), function (props) {
    return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      border-radius: ", "px;\n      border: ", "px solid ", ";\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      border-radius: ", "px;\n      border: ", "px solid ", ";\n      width: ", "px;\n      height: ", "px;\n    "])), props.borderRadius || 0, props._borderWidth, theme.COLOR(props._borderColor), props.size, props.size);
  }, function (props) {
    return !props.disabled && css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n      &:hover {\n        border-color: ", ";\n      }\n    "], ["\n      &:hover {\n        border-color: ", ";\n      }\n    "])), theme.COLOR(props._borderColorHover));
  }, function (props) {
    return !props.valid && css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      border-color: ", ";\n    "], ["\n      border-color: ", ";\n    "])), theme.COLOR('error'));
  })
});
// -------- Components -------->
var My = {
  Container: styled.label(templateObject_13 || (templateObject_13 = __makeTemplateObject([""], [""]))),
  ActualInput: styled.input(templateObject_14 || (templateObject_14 = __makeTemplateObject([""], [""]))),
  Label: styled.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Icon: styled(Icon)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Checkbox: styled.div(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), CheckboxStyles),
  Body: styled.span(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles)
};
My.Container = styled.label(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  ", "\n  &:hover ", " {\n    ", "\n  }\n"], ["\n  ", "\n  &:hover ", " {\n    ", "\n  }\n"])), ContainerStyles, My.Checkbox, function (props) {
  return !props.disabled && css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      border-color: ", ";\n    "], ["\n      border-color: ", ";\n    "])), theme.COLOR(props._borderColorHover));
});
My.ActualInput = styled.input(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  ", "\n\n  &:focus ~ ", " {\n    transition: border-color 0.25s;\n    border-color: ", ";\n  }\n\n  &:focus ~ ", " {\n    color: ", ";\n  }\n"], ["\n  ", "\n\n  &:focus ~ ", " {\n    transition: border-color 0.25s;\n    border-color: ", ";\n  }\n\n  &:focus ~ ", " {\n    color: ", ";\n  }\n"])), InputStyles, My.Checkbox, theme.COLOR('primary'), My.Label, theme.COLOR('primary'));
export var Checkbox = function (props) {
  var className = props.className,
    valid = props.valid,
    name = props.name,
    checked = props.checked,
    value = props.value,
    id = props.id,
    size = props.size,
    disabled = props.disabled,
    loading = props.loading,
    onChange = props.onChange,
    children = props.children,
    borderWidth = props.borderWidth,
    borderColor = props.borderColor,
    borderColorHover = props.borderColorHover,
    borderRadius = props.borderRadius;
  var iconSize = size - 2 * borderWidth - 6;
  var Icon = props.icon || TickIconGlyph;
  var $ = useThemeEval();
  var primary = $(theme.COLOR('primary'));
  var handleChange = function (event) {
    var target = event.target;
    onChange(target && target.checked);
  };
  return React.createElement(My.Container, {
    disabled: disabled || loading,
    className: className,
    _borderColorHover: borderColorHover,
    valid: valid
  }, React.createElement(My.ActualInput, {
    disabled: disabled,
    name: name || id,
    checked: !!checked,
    value: value,
    onChange: handleChange,
    type: "checkbox"
  }), React.createElement(My.Checkbox, {
    borderRadius: borderRadius,
    disabled: disabled,
    id: id,
    _borderWidth: borderWidth,
    _borderColor: borderColor,
    _borderColorHover: borderColorHover,
    size: size,
    valid: valid
  }, checked && !loading && React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(Icon, null)), loading && React.createElement(Spinner, {
    color: primary,
    size: iconSize - 2
  })), children && React.createElement(My.Body, null, children));
};
Checkbox.defaultProps = CheckboxDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21;